var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFullPinterest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67398",
    "data-name": "Group 67398",
    transform: "translate(-0.17 0.245)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22932",
    "data-name": "Rectangle 22932",
    width: 24,
    height: 24,
    rx: 7,
    transform: "translate(0.17 -0.245)",
    fill: "#cf2d2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-pinterest-p",
    "data-name": "Icon awesome-pinterest-p",
    d: "M6.265.457C3.114.457,0,2.558,0,5.957c0,2.162,1.216,3.39,1.953,3.39.3,0,.479-.848.479-1.087,0-.286-.728-.894-.728-2.082a4.15,4.15,0,0,1,4.312-4.22c2.091,0,3.639,1.188,3.639,3.372,0,1.631-.654,4.689-2.773,4.689A1.364,1.364,0,0,1,5.463,8.675c0-1.161.811-2.285.811-3.483,0-2.033-2.884-1.664-2.884.792a3.608,3.608,0,0,0,.295,1.557C3.261,9.366,2.4,12.084,2.4,13.963c0,.58.083,1.152.138,1.732.1.117.052.1.212.046,1.548-2.119,1.493-2.534,2.193-5.307A2.491,2.491,0,0,0,7.066,11.54c3.261,0,4.726-3.178,4.726-6.044C11.793,2.447,9.158.457,6.265.457Z",
    transform: "translate(6.273 4.364)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFullPinterest);
export default __webpack_public_path__ + "static/media/icon-full-pinterest.893e5b7ad7e30be5c0373af65d502236.svg";
export { ForwardRef as ReactComponent };